import { useFormContext } from 'react-hook-form';
import { TextField as Input } from '@mui/material';

interface ITextFieldInputs {
  name: string;
  label: string;
  multiline?: boolean;
  numericInput?: boolean;
  min?: number;
  max?: number;
  required?: boolean;
  autoFocus?: boolean;

  /* onChange & value are only required if state has to be manually adjusted. Else, leave as undefined. */
  onChange?: (event: { target: { value: string } }) => void;
  value?: string;
}

export function TextField(props: ITextFieldInputs) {
  const {
    name,
    label,
    onChange,
    value,
    multiline,
    numericInput,
    min,
    max,
    required = false,
    autoFocus = false,
  } = props;
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const getValidationMessage = () => {
    if (min && max) {
      return `${label} must be between ${min} and ${max}`;
    } else if (max) {
      return `${label} must be at most ${max}`;
    }
    return `${label} must be atleast ${min}`;
  };

  return (
    <Input
      id={name}
      label={label}
      value={value}
      fullWidth
      autoFocus={autoFocus}
      autoComplete="off"
      multiline={multiline}
      minRows={3}
      type={numericInput ? 'number' : 'text'}
      error={Boolean(errors[name])}
      helperText={errors[name]?.message}
      inputProps={numericInput ? { ...{ inputMode: 'numeric', pattern: '[0-9]*' } } : undefined}
      {...register(name, {
        required: required && `${label} is required.`,
        onChange: e => onChange && onChange(e),
        min: min && {
          value: min,
          message: getValidationMessage(),
        },
        max: max && {
          value: max,
          message: getValidationMessage(),
        },
      })}
    />
  );
}
